import {useGetData} from '../../src/apiservice/apiCall'


export function useCertificates(){
	return useGetData('/api/WebApi/GetCertificate')
}
